import { W } from '@angular/cdk/keycodes';
import { DOCUMENT, NgClass } from '@angular/common';
import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { FeedbackWidget, widget_type } from 'src/_model/storyblock';
import { GlobalService } from 'src/_service/GlobalService';
import { WINDOW } from 'src/_service/WindowService';

@Component({
  selector: 'app-cms-feedbackwidget',
  standalone: true,
  imports: [NgClass],
  templateUrl: './cms-feedbackwidget.component.html',
  styleUrl: './cms-feedbackwidget.component.scss'
})
export class CmsFeedbackwidgetComponent {

  widget: FeedbackWidget
  @Input() set feedbackwidget(value: FeedbackWidget) {
    this.widget = value;
    switch (value.widget_type) {
      case (widget_type.BAR): this.uuid = "82741ec8-f4b4-44af-9491-d4e53679f7f0"; break;
      case (widget_type.BLOCK): this.uuid = "d774202a-a092-4af3-91a7-5c31bf0a98d1"; break;
      case (widget_type.SIDE): this.uuid = "079b8121-af58-477c-ba26-dfc0e15b0afe"; break;
    }
  }

  uuid: string
  rnd: any

  @ViewChild('widgetRef') widgedRef: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document,
    @Inject(WINDOW) private window: Window,
    private elementRef: ElementRef,
    private _globalService: GlobalService,
  ) {

  }

  ngOnInit() {
    this.rnd = this._globalService.createRandomString(8)
  }



  ngAfterViewInit() {
    const b = this.document.createElement('script');
    b.type = 'text/javascript';
    b.id = '__fbcw__' + this.rnd + this.uuid;
    // this.elementRef.nativeElement.getElementById('feedbackwidget-'+ this.rnd).appendChild(b);
    this.document.getElementById('feedbackwidget-' + this.rnd).appendChild(b);
    // this.widgedRef.nativeElement.appendChild(b)

    const w = this.window as any

    w.FeedbackCompanyWidgets = w.FeedbackCompanyWidgets || { queue: [], loaders: [] };
    var options = { uuid: this.uuid, version: "1.2.1", prefix: this.rnd };
    if (void 0 === w.FeedbackCompanyWidget) {
      if (w.FeedbackCompanyWidgets.queue.push(options), !document.getElementById("__fbcw_FeedbackCompanyWidget")) {
        var scriptTag = document.createElement("script");
        scriptTag.onload = function () {
          if (w.FeedbackCompanyWidget)
            for (; 0 < w.FeedbackCompanyWidgets.queue.length;)
              options = w.FeedbackCompanyWidgets.queue.pop(),
                w.FeedbackCompanyWidgets.loaders.push(
                  new w.FeedbackCompanyWidgetLoader(options)
                )
        },
          scriptTag.id = "__fbcw_FeedbackCompanyWidget",
          scriptTag.src = "https://www.feedbackcompany.com/includes/widgets/feedback-company-widget.min.js",
          document.body.appendChild(scriptTag)
      }
    } else {
      w.FeedbackCompanyWidgets.loaders.push(new w.FeedbackCompanyWidgetLoader(options))
    }

  }
}

